const cardImageTemplates = [...document.querySelectorAll('[data-ct-card-image]')];
function loadAttractionCardImage(template) {
  if (!template.isConnected) return;
  const image = template.content.querySelector('img').cloneNode(true);
  image.loading = 'eager';
  template.replaceWith(image);
}

if ('IntersectionObserver' in window) {
  // Native lazy loading can fetch several screens ahead of the first viewport.
  const imageObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const template = entry.target.querySelector('[data-ct-card-image]');
      if (template) loadAttractionCardImage(template);
      imageObserver.unobserve(entry.target);
    });
  }, {rootMargin: '300px 0px', threshold: 0});
  cardImageTemplates.forEach(template => imageObserver.observe(template.parentElement));
} else {
  cardImageTemplates.forEach(loadAttractionCardImage);
}

window.addEventListener('beforeprint', () => cardImageTemplates.forEach(loadAttractionCardImage));
document.body.classList.add('ct-attractions-page');

function positionAttractionCurrency() {
  const currency = document.querySelector('.bacurr-cur-block');
  if (!currency) return false;
  currency.style.setProperty('position', 'absolute', 'important');
  return true;
}

if (!positionAttractionCurrency()) {
  let frame;
  const stop = () => {
    currencyObserver.disconnect();
    clearTimeout(timeout);
    cancelAnimationFrame(frame);
  };
  const currencyObserver = new MutationObserver(() => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = undefined;
      if (positionAttractionCurrency()) stop();
    });
  });
  const timeout = setTimeout(stop, 60000);
  currencyObserver.observe(document.body, {childList: true, subtree: true});
}

document.querySelectorAll('.ct-attractions__nav, .ct-attraction-detail__toc').forEach((nav) => {
  nav.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#"]');
    if (!link) return;
    const target = document.getElementById(link.hash.slice(1));
    if (!target) return;
    event.preventDefault();
    target.querySelectorAll('[data-ct-card-image]').forEach(loadAttractionCardImage);
    const header = document.querySelector('header-component');
    const offset = (header?.getBoundingClientRect().height || 96) + 20;
    const top = window.scrollY + target.getBoundingClientRect().top - offset;
    window.scrollTo({ top, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    history.replaceState(null, '', link.hash);
    nav.querySelectorAll('a').forEach(item => item.removeAttribute('aria-current'));
    link.setAttribute('aria-current', 'location');
  });
});

const detail = document.querySelector('.ct-attraction-detail');
if (detail) {
  const navigation = detail.querySelector('.ct-attraction-detail__toc');
  const sections = [...navigation.querySelectorAll('a')].map(link => detail.querySelector(link.hash)).filter(Boolean);
  const sectionObserver = new IntersectionObserver(entries => {
    const visible = entries.filter(entry => entry.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
    if (!visible.length) return;
    navigation.querySelectorAll('a').forEach(link => {
      if (link.hash === '#' + visible[0].target.id) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
  }, { rootMargin: '-120px 0px -55% 0px', threshold: 0 });
  sections.forEach(section => sectionObserver.observe(section));

  const photos = [...detail.querySelectorAll('[data-gallery-photo]')];
  const dialog = detail.querySelector('.ct-attraction-lightbox');
  if (dialog && photos.length) {
    const image = dialog.querySelector('.ct-attraction-lightbox__image');
    const caption = dialog.querySelector('.ct-attraction-lightbox__caption');
    const counter = dialog.querySelector('.ct-attraction-lightbox__counter');
    let current = 0;
    let trigger;
    let previousOverflow;
    const show = index => {
      current = (index + photos.length) % photos.length;
      image.src = photos[current].dataset.gallerySrc;
      image.alt = photos[current].dataset.galleryAlt;
      caption.textContent = image.alt;
      counter.textContent = (current + 1) + ' / ' + photos.length;
    };
    photos.forEach((photo, index) => photo.addEventListener('click', () => {
      trigger = photo;
      show(index);
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      dialog.showModal();
    }));
    const previous = dialog.querySelector('[data-gallery-previous]');
    const next = dialog.querySelector('[data-gallery-next]');
    previous.hidden = next.hidden = photos.length < 2;
    previous.addEventListener('click', () => show(current - 1));
    next.addEventListener('click', () => show(current + 1));
    dialog.querySelector('[data-gallery-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        show(current + (event.key === 'ArrowLeft' ? -1 : 1));
      }
    });
    dialog.addEventListener('click', event => {
      const rect = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.body.style.overflow = previousOverflow || '';
      trigger?.focus({ preventScroll: true });
    });
  }
}
